import { Box, styled, Typography } from '@mui/material';

export const ContainerView = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
  flexDirection: 'column',
}));

export const ChoiceContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderRadius: '6px',
  border: '1px solid',
  borderColor: theme.palette.divider,
  flex: 1,
  minWidth: '300px',
  height: 'fit-content',
}));

export const TitleText = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 24,
  margin: '8px 0px',
  textAlign: 'center',
}));

export const SubTitleText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.secondary,
}));

export const TitleBox = styled(Box)(() => ({
  paddingBottom: '16px',
  alignItems: 'center',
  textAlign: 'center',
}));

export const ContentBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));
